import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';

import styles from './HistoryGroupLoader.module.scss';

export const HistoryGroupLoader = () => (
  <div className={styles.root}>
    <div className={styles.flexColumn}>
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '80px',
              height: '16px',
              borderRadius: '8px',
              marginLeft: '16px',
            },
          },
        ]}
      />
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '240px',
              height: '24px',
              borderRadius: '8px',
              marginLeft: '10px',
            },
          },
        ]}
      />
    </div>
    <div className={styles.flexColumn}>
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '80px',
              height: '16px',
              borderRadius: '8px',
              marginLeft: '16px',
            },
          },
        ]}
      />
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '164px',
              height: '24px',
              borderRadius: '8px',
              marginLeft: '10px',
            },
          },
        ]}
      />
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '205px',
              height: '24px',
              borderRadius: '8px',
              marginLeft: '10px',
            },
          },
        ]}
      />
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '240px',
              height: '24px',
              borderRadius: '8px',
              marginLeft: '10px',
            },
          },
        ]}
      />
    </div>
  </div>
);
